import { Store } from "vuex";
import Reactions from "@/helpers/reactions/reactions";
import { CHAT_TYPE } from "@/resources/constants/chat";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import GraphicClient from "@/resources/mixins/graphicClient/graphicClient";
import { MessageType, UserSendMessageType } from "@/resources/constants/graphicClient/graphicClient";
export default class SpaceSocketHandler {
  /**
   * SPACE_SCENARIO_CHANGED
   * */
  static async spaceScenarioChanged(
    store?: Store<any>,
    data?: any
  ): Promise<void> {
    //await store.dispatch("SpaceStore/setSpaceAction", data);
    location.reload();
  }
  /**
   * SPACE_ENABLED
   * */
  static async spaceEnabled(store?: Store<any>, data?: any): Promise<void> { }
  /**
   * SPACE_DISABLED
   * */
  static async spaceDisabled(store?: Store<any>, data?: any): Promise<void> {
    const user = store.getters["UserStore/getSpaceUser"];
    if (!user.isAdmin) {
      await store.dispatch("GraphicClientStore/spaceDisable", data);
      await store.dispatch("AuthStore/logOutAction");
    }
  }
  /**
   * SPACE_SPACE_EDITED
   * */
  static async spaceChanged(store?: Store<any>, data?: any): Promise<void> {
    await store.dispatch("SpaceStore/setSpaceNameAction", data);
    await store.dispatch("SpaceStore/setSpaceAction", data);
    //TODO  update isMultiWebinarActivated
    await store.dispatch(
      "GraphicClientStore/updateMultiWebinar",
      data.superSpace.isMultiWebinarActivated
    );
    const openChat = store.getters["SidebarStore/getOpenChat"];
    const chatType = store.getters["ChatStore/getChatType"];
    const meetingType = store.getters["MeetingStore/getMeetingType"];
    if (
      openChat &&
      ((!data.isChatActive && chatType === CHAT_TYPE.SPACE) ||
        (!data.isWebinarChatActive &&
          chatType === CHAT_TYPE.ROOM &&
          meetingType === MEETING_TYPE.WEBINAR))
    ) {
      await store.dispatch("SidebarStore/setOpenChatAction", false);
      await store.dispatch("ChatStore/setUserChatAction", null);
      await store.dispatch("ChatStore/setMessagesAction", []);
      await store.dispatch("ChatStore/setChatTypeAction", CHAT_TYPE.ONE_TO_ONE);
    }
    const worker = store.getters["WorkerStore/getWorker"];
    worker.postMessage({
      nameSpace: " - " + data.name,
    });
    //await store.dispatch("SpaceStore/setSpaceAction", data);
  }
  /**
   * SPACE_IMAGE_UPDATED
   * */
  static async spaceImageUpdate(store?: Store<any>, data?: any): Promise<void> {
    await store.dispatch("SpaceStore/setSpaceImageUpdateAction", data);
    await store.dispatch("GraphicClientStore/updateSpace", data);
    //await store.dispatch("SpaceStore/setSpaceAction", data);
  }
  /**
   * SPACE_DELETED
   * */
  static async spaceDeleted(store?: Store<any>, data?: any): Promise<void> { }
  /**
   * MAINTENANCE_ON
   */
  static async maintenanceOn(store?: Store<any>, data?: any): Promise<void> {
    await store.dispatch(
      "SystemStore/setMaintenanceStartAction",
      data.MAINTENANCE_START_AT
    );
    await store.dispatch(
      "SystemStore/setMaintenaceFinishAction",
      data.MAINTENANCE_FINISH_AT
    );
    localStorage.setItem("maintenance", "on");
    window.location.reload();
  }
  /**
   * MAINTENANCE_OFF
   */
  static async maintenanceOff(store?: Store<any>, data?: any): Promise<void> {
    localStorage.setItem("nubii_version", data.NUBII_VERSION);
    localStorage.setItem("maintenance", "off");
    window.location.reload();
    await store.dispatch("SystemStore/setMaintenanceModalAction", false);
  }
  /**
   * EXTEND_MAINTENANCE
   */
  static async maintenanceExtend(
    store?: Store<any>,
    data?: any
  ): Promise<void> {
    await store.dispatch(
      "SystemStore/setMaintenanceStartAction",
      data.MAINTENANCE_START_AT
    );
    await store.dispatch(
      "SystemStore/setMaintenaceFinishAction",
      data.MAINTENANCE_FINISH_AT
    );
  }

  static async cancelNextMaintenance(store?: Store<any>): Promise<void> {
    await store.dispatch("FloatMenuStore/setShowNextMaintenanceAction", false);
  }

  /**
   * SPACE_EMOJI_REACTION
   * */
  static async spaceEmojiReaction(
    store?: Store<any>,
    data?: any
  ): Promise<void> {
    const reactions = new Reactions();
    reactions.addReaction(store, data);
    await store.dispatch("GraphicClientStore/emojiReaction", data);
  }
  /**
   * NEXT_MAINTENANCE
   */
  static async nextMaintenance(store?: Store<any>, data?: any): Promise<void> {
    await store.dispatch(
      "FloatMenuStore/setTimeNextMaintenanceAction",
      data.NEXT_MAINTENANCE_AT
    );
    await store.dispatch("FloatMenuStore/setShowNextMaintenanceAction", true);
  }
  /**
   * POSTER_UPDATED
   */
  static async posterUpdate(store?: Store<any>, data?: any): Promise<void> {
    store.dispatch("SpaceStore/setPosterAction", data.data);
    await store.dispatch("GraphicClientStore/posterUpdateAction", data.data);
  }
  /**
   * POSTER_IMAGE_UPDATED
   */
  static async posterImageUpdate(
    store?: Store<any>,
    data?: any
  ): Promise<void> {
    // TODO: CAMBIAR IMAGEN EN EL CLIENTE GRAFICO
    store.dispatch("SpaceStore/setPosterAction", data.data);
    await store.dispatch("GraphicClientStore/posterUpdateAction", data.data);
  }
  /**
   * GLOBAL_PARAMS_UPDATED
   */
  static async globalParamsUpdated(
    store?: Store<any>,
    data?: any
  ): Promise<void> {
    localStorage.setItem("SPEED_NETWORKING_WAITING_TIME_BETWEEN_CYCLES", data.SPEED_NETWORKING_WAITING_TIME_BETWEEN_CYCLES ?? "15");
    localStorage.setItem("WEB_CLIENT_LOG_ACTIVATED", data.WEB_CLIENT_LOG_ACTIVATED);
    localStorage.setItem("nubii_version", data.NUBII_VERSION);
    localStorage.setItem("isAiActicated", data.IS_AI_ACTIVATED);
    await store.dispatch("SystemStore/setMaintenaceFinishAction", data.MAINTENANCE_FINISH_AT);
    await store.dispatch("SystemStore/setMaintenanceStartAction", data.MAINTENANCE_START_AT);
    await store.dispatch("FloatMenuStore/setTimeNextMaintenanceAction", data.NEXT_MAINTENANCE_AT);
  }
  /**
   * GAEM_KILLER
   */
  static async Started(
    store?: Store<any>,
    data?: any
  ): Promise<void> {
    store.dispatch("SystemStore/setGameKillerInfoModalAction", false);
    store.dispatch("UserStore/setGameKillerAction", false);
    GraphicClient.sendMessage(
      MessageType.USER,
      UserSendMessageType.YOU_KILL,
      true
    );
    store.dispatch("GameKillerStore/setGameKillerTimerReportAction",0);
    store.dispatch("GameKillerStore/setGameKillerTimerVoteAction",0);
    store.dispatch("GameKillerStore/setGameKillerTimerKillerAction", 0);
    store.dispatch("GameKillerStore/setGameKillerTimerBanAction", 0);
    store.dispatch("SystemStore/setGameKillerVoteAndWinnerModalAction", false);
    store.dispatch("GameKillerStore/setGameKillerLastDeadAction", null);
    let spaceUser = store.getters["UserStore/getSpaceUser"];
    if (spaceUser) {
      spaceUser.isDeadInAssassinGame = false;
      store.dispatch("UserStore/setSpaceUserLocal", spaceUser);
    }
    store.dispatch("GameKillerStore/setGameKillerUserVotedAction", false);
    store.dispatch("GameKillerStore/setGameKillerDataAction", null);
    store.dispatch("SystemStore/setGameKillerModalAction", true);
    store.dispatch("GameKillerStore/setGameKillerDataAction", data);
    let space = store.getters["SpaceStore/getSpace"];
    space.isAssassinGameActivated = true;
    store.dispatch("SpaceStore/setSpaceAction", space);
    store.dispatch("SystemStore/setGameKillerInfoModalAction", true);
  }
}
